var GridRow = require("app/ui/repeaters/GridRow"),
    get     = require("object-path").get,
    kind    = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.repeaters.ProductCategoryGridRow.prototype */ {

    /**
     * @private
     */
    name: "app.ui.repeaters.ProductCategoryGridRow",

    /**
     * @private
     */
    kind: GridRow,

    /**
     * @private
     */
    classes: "app-ui-repeaters-product-category-grid-row",

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: function() {
        var i18nService     = this.app.$.i18nService,
            data            = this.data || {},
            moreLink        = get(data, "links.self", null),
            childFormat     = get(data, "category_layout.format", "cover"),
            childFormFactor = get(data, "category_layout.formfactor", "portrait"),
            childSize       = get(data, "category_layout.size", "md"),
            showTitles      = get(data, "category_layout.show_titles", true),
            $moreButton     = this.$.moreButton,
            $grid           = this.$.grid,
            needsReflow     = false;

        this.$.title.set("content", get(data, "meta.title", null) || "");

        if (this.get("showMoreButton")
            && moreLink
            && moreLink !== this.app.$.router.getCurrentPath()) {
            $moreButton.show();
            $moreButton.set("href", moreLink);
        }
        else {
            $moreButton.hide();
            $moreButton.set("href", null);
        }
        $moreButton.set("caption", i18nService.getString("app.ui.repeaters.GridRow.moreButton.caption"));

        // The properties below can impact the arrangement of the repeater so
        // they need to be applied before we trigger a draw cycle by updating
        // the repeater's dataset.
        if (childFormFactor !== $grid.get("childFormFactor")) {
            $grid.set("childFormFactor", childFormFactor);
            needsReflow = true;
        }

        if (childSize !== $grid.get("childSize")) {
            $grid.set("childSize", childSize);
            needsReflow = true;
        }

        if (showTitles !== $grid.get("showTitles")) {
            $grid.set("showTitles", showTitles);
            needsReflow = true;
        }
        $grid.set("showNewRibbons",  get(data, "category_type", null) !== "recently-added");

        // The properties below will impact the arrangement of the repeater so
        // they need to be applied before we trigger a draw cycle by updating
        // the repeater's dataset.
        if (childFormat !== $grid.get("childFormat")) {
            $grid.set("childFormat", childFormat);
            $grid.destroyChildren();

            // We also need to replace the layoutPlaceholder, because it's used
            // to determine the amount of columns shown in the grid.
            $grid.arranger.resetLayoutChild();
            needsReflow = true;
        }

        // Now that the grid's arrangement settings are all updated we can
        // reflow
        needsReflow && $grid.reflow();

        // This will trigger the repeater to re-draw. As such, any changes
        // resulting from either the dataset or the repeater options applied
        // above will be taken care of by the draw cycle.
        $grid.set("data", get(data, "children", []));
    }

});
